import script from "./StudentCompare.vue?vue&type=script&setup=true&lang=ts"
export * from "./StudentCompare.vue?vue&type=script&setup=true&lang=ts"

import "./StudentCompare.vue?vue&type=style&index=0&id=abfdcce6&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-abfdcce6"]])

export default __exports__